import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../services/login";
import { getStoredValue } from "../services/logics";
import RotatingLoader from "../assets/RotatingLoader.jsx";

const ProtectedAdminRoutes = () => {
  const [authStatus, setAuthStatus] = useState("checking");

  const isSuperAdmin = getStoredValue("is_super_admin");
  const store_id = getStoredValue("storeid");
  const token = getStoredValue("token");
  const isLoggedIn = getStoredValue("isLoggedIn");

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { success } = await isAuthenticated();
        setAuthStatus(success ? "authenticated" : "unauthenticated");
      } catch (error) {
        console.error("Authentication error:", error);
        setAuthStatus("unauthenticated");
      }
    };

    checkAuth();
  }, []);

  if (authStatus === "checking") {
    return (
      <div className="flex items-center justify-center h-screen">
        <RotatingLoader />
      </div>
    );
  }

  // Match PrivateLayout: a stale token left over from before a logout's
  // storage.clear() must not let this guard through on its own - isLoggedIn is
  // what logout actually flips to "false", so it's the signal that's trusted here,
  // not token presence.
  if (authStatus === "unauthenticated" && isLoggedIn !== "true") {
    return <Navigate to="/admin-signin" replace />;
  }

  if (!token) {
    return <Navigate to="/admin-signin" replace />;
  }

  if (isSuperAdmin === "True" && store_id === "undefined") {
    return <Outlet />;
  }
  return <Navigate to="/error" replace />;
};

export default ProtectedAdminRoutes;
